<template>
    <div>
        <nav class="navbar navbar-expand-md navbar-dark bg-primary sticky-top">
            <div class="container-fluid">
                <!-- Right Side Of Navbar -->
                <ul class="navbar-nav ml-auto">
                    <!-- Authentication Links -->
                    <li class="nav-item">
                        <a class="nav-link" href="/admin">
                            <i class="text-red-light fas fa-sign-in-alt"></i>Admin
                        </a>
                    </li>
                </ul>
            </div>
        </nav>
        <main>
            <div class="container-fluid">
                <div class="row full-screen-height">
                    <div class="col-lg-4 col-md-6 p-4">
                        <br />
                        <br />
                        <h2 class="t-800 text-secondary">Canon</h2>
                        <p>Preencha os campos abaixo para entrar no sistema.</p>
                        <!-- <div class="alert alert-danger" v-if="error">{{ error }}</div> -->
                        <form method="POST" @submit.prevent="login" aria-label="Login">
                            <input
                                type="hidden"
                                name="_token"
                                value="MZbIl01JvIHWqmf2gUgBQoMl2RF0Bz25OWsAHcFh"
                            />
                            <transition name="error">
                                <div v-show="error" class="row">
                                    <div class="col-md-12">
                                        <div class="alert alert-danger">
                                            <i class="fas fa-exclamation-triangle"></i> E-mail ou senha incorretos.
                                        </div>
                                    </div>
                                </div>
                            </transition>
                            <div class="form-group row">
                                <div class="col-md-12">
                                    <input
                                        id="email"
                                        type="email"
                                        class="form-control"
                                        v-model="email"
                                        value
                                        v-bind:class="{ has_error: error }"
                                        required
                                        autofocus
                                        placeholder="E-Mail"
                                    />
                                </div>
                            </div>
                            <div class="form-group row">
                                <div class="col-md-12">
                                    <transition name="error">
                                        <input
                                            id="password"
                                            type="password"
                                            class="form-control"
                                            v-model="password"
                                            v-bind:class="{ has_error: error }"
                                            required
                                            placeholder="Password"
                                        />
                                    </transition>
                                </div>
                            </div>
                            <div class="form-group row mb-0">
                                <div class="col-md-12">
                                    <button type="submit" class="btn btn-primary">Login</button>
                                    <!-- <a class="btn btn-link" href="#">Forgot Your Password?</a> -->
                                </div>
                            </div>
                        </form>
                    </div>
                    <div class="col-lg-8 col-md-6 bg-home"></div>
                </div>
            </div>
        </main>
    </div>
</template>

<script>
import { mapState } from "vuex";
import { navigateAfterLogin } from "@/router/authNavigation";
export default {
  name: "Home",
  data() {
    return {
      email: "",
      password: "",
      error: false
    };
  },
  computed: {
    ...mapState(["auth"])
  },
  events: {
    hideMessage: function() {
      this.error = false;
    }
  },
  methods: {
    login() {
      this.$store
        .dispatch("auth/auth_request", {
          email: this.email,
          password: this.password
        })
        .then(() => {
          return navigateAfterLogin(this.$router, this.$store.getters["auth/getSessionRoles"]);
        })
        .catch(error => {
          if (error.requires2fa) {
            this.$router.push({ name: "two-factor" });
            return;
          }
          this.error = true;
          setTimeout(
            function() {
              this.error = false;
            }.bind(this),
            3000
          );
        });
    }
  }
};
</script>
<style>
.error-enter-active,
.error-leave-active {
  transition: opacity 0.75s;
}
.error-enter,
.error-leave-to {
  opacity: 0;
}
.has_error {
  border: 1px solid #cc0000 !important;
}
</style>
